import { useTranslation } from "react-i18next";
import TableState from "../../components/ui/TableState";
import { StyledTableCell, StyledTableRow, TableWrapper } from "../../components/ui/table";
import {
  Box,
  Chip,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import React from "react";
import { useNavigate } from "react-router-dom";
import { BreefInviteTrackingSummary } from "../../redux/slices/BreefInviteSlice";




interface BreefTrackingTableProps {
  results: BreefInviteTrackingSummary[];
}

const BreefTrackingTable: React.FC<BreefTrackingTableProps> = ({ results }) => {
  const navigate = useNavigate();
  const [t] = useTranslation("global");

  return (
    <TableWrapper component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableCell align="center">{t("tracking.breefName")}</StyledTableCell>
            <StyledTableCell align="center">{t("tracking.customer")}</StyledTableCell>
            <StyledTableCell align="center">{t("tracking.sent")}</StyledTableCell>
            <StyledTableCell align="center">{t("tracking.failed")}</StyledTableCell>
            <StyledTableCell align="center">{t("tracking.pending")}</StyledTableCell>
            <StyledTableCell align="center">{t("tracking.actions")}</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {results.length === 0 && <TableState colSpan={6} text={t("tracking.none")} />}
          {results.map((breef) => (
            <StyledTableRow key={breef.breefId}>
              <TableCell align="center">{breef.breefName}</TableCell>
              <TableCell align="center">
                <Box>{breef.tenantName}</Box>
                <Box sx={{ fontSize: "0.8em", color: "text.secondary" }}>
                  {breef.tenantEmail || breef.tenantPhone}
                </Box>
              </TableCell>
              <TableCell align="center">
                <Chip label={breef.sentCount} color={breef.sentCount ? "success" : "default"} size="small" />
              </TableCell>
              <TableCell align="center">
                <Chip label={breef.failedCount} color={breef.failedCount ? "error" : "default"} size="small" />
              </TableCell>
              <TableCell align="center">
                <Chip label={breef.pendingCount} color={breef.pendingCount ? "warning" : "default"} size="small" />
              </TableCell>
              <TableCell align="center">
                <IconButton aria-label="view" onClick={() => navigate(`/breef-tracking/${breef.breefId}`)}>
                  <VisibilityIcon />
                </IconButton>
              </TableCell>
            </StyledTableRow>
          ))}
          {results.length === 0 && (
            <TableRow>
              <TableCell colSpan={6} align="center">
                No breefs found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableWrapper>
  );
};

export default BreefTrackingTable;
